import React from "react";
import ClayPanel from "@clayui/panel";
import ClaySticker from "@clayui/sticker";
import ClayIcon from "@clayui/icon";
import { Text } from "@clayui/core";
import { RELATIONSHIP, OBJECT_ENTRY_URL_SEPARATOR } from "../../utils/constants";

const NavigationModule = ({
	getLessonIndex,
	getModuleIndex,
	index,
	isLessonCompleted,
	isModuleCompleted,
	moduleLabel,
	navigationMenuItem,
}) => {
	const quizzes = navigationMenuItem[RELATIONSHIP.MODULES_TO_QUIZZES] ?? [];
	const quizById = new Map(quizzes.map((q) => [q.id, q]));

	return (
		<ClayPanel
			collapsable
			displayType="secondary"
			className="border-0 mb-0"
			collapseHeaderClassNames={`${navigationMenuItem.active ? "active" : ""}`}
			displayTitle={
				<div className={`d-flex`}>
					<div>
						<ClaySticker shape="circle" displayType={"unstyled"} size="md">
							{isModuleCompleted(navigationMenuItem.id) ? (
								<ClayIcon symbol="check" />
							) : (
								getLessonIndex(navigationMenuItem.id, index)
							)}
						</ClaySticker>
					</div>

					<span
						title={`${moduleLabel} ${getModuleIndex(navigationMenuItem.id)}: 
							${
								navigationMenuItem.title === ""
									? navigationMenuItem.name
									: navigationMenuItem.title
							}`}
						className="module-title my-auto px-2"
					>
						<Text size={4} weight={"semi-bold"}>
							{`${moduleLabel} ${getModuleIndex(navigationMenuItem.id)}: 
								${navigationMenuItem.title === "" ? navigationMenuItem.name : navigationMenuItem.title}`}
						</Text>
					</span>
				</div>
			}
			showCollapseIcon={true}
			key={navigationMenuItem.id}
			defaultExpanded={navigationMenuItem.active}
		>
			<ClayPanel.Body className="p-0">
				{navigationMenuItem[RELATIONSHIP.MODULES_TO_LESSONS] &&
					navigationMenuItem[RELATIONSHIP.MODULES_TO_LESSONS].map((item, index) => {
						const quiz = quizById.get(item.id);
						const url = quiz?.id
							? quiz.friendlyUrlPath
								? `/${OBJECT_ENTRY_URL_SEPARATOR.QUIZ}/${quiz.friendlyUrlPath}`
								: null
							: item?.friendlyUrlPath
								? `/${OBJECT_ENTRY_URL_SEPARATOR.LESSON}/${item.friendlyUrlPath}`
								: null;

						return (
							<div
								className={`align-items-center d-flex px-3 py-3 lesson-link ${
									isLessonCompleted(item.id) ? "completed" : "not-completed"
								} ${item.active ? "active" : ""}`}
								key={index}
							>
								<ClaySticker shape="circle" displayType="primary" size="md">
									{isLessonCompleted(item.id) ? (
										<ClayIcon symbol="check" />
									) : (
										""
									)}
								</ClaySticker>
								<span className="module-title my-auto px-2">
									<Text size={4} weight={"semi-bold"}>
										<a
											style={{ textDecoration: "none" }}
											href={url}
										>
											{item.title === "" ? item.title_i18n.en_US : item.title}
										</a>
									</Text>
								</span>
							</div>
						);
					})}
			</ClayPanel.Body>
		</ClayPanel>
	);
};

export default NavigationModule;
